<template>
  <div>
    <div v-if="area" class="stock-info-area">
      {{ $t('find.APPROX') }} {{ area }} {{ $t('find.SQFT') }}
      <span v-if="atticArea">+ {{ $t('find.ATTIC') }}{{ $t('find.APPROX') }} {{ atticArea }} {{ $t('find.SQFT') }}</span>
    </div>
  </div>
</template>

<script>
import numberFormatMixin from '@/mixins/numberFormat';

export default {
  props: ['stock'],
  mixins: [numberFormatMixin],
  computed: {
    area() {
      let ret = null;
      const minArea = parseInt(this.stock.min_area, 10);
      const area = parseInt(this.stock.area, 10);
      if (minArea && minArea !== area) {
        ret = `${this.fmt(minArea)} - `;
      }
      if (area) {
        if (!ret) {
          ret = '';
        }
        ret += this.fmt(area);
      }
      return ret;
    },
    atticArea() {
      const atticArea = parseInt(this.stock.attic_area, 10);
      return atticArea > 0 ? this.fmt(atticArea) : null;
    },
  },
};
</script>

<style scoped>
</style>